import SelectPeople from './container';

export default SelectPeople;
